import { GlobalState } from '../actions';

const blogSelector = (state: GlobalState) => state.blog;

export const blogListSelector = (state: GlobalState) => blogSelector(state).blogList;
export const blogEntitySelector = (state: GlobalState) => blogSelector(state).blog;